import { render, staticRenderFns } from "./ListaSolicitacoesPlanoSaude.vue?vue&type=template&id=0ec3a19a&"
import script from "./ListaSolicitacoesPlanoSaude.vue?vue&type=script&lang=js&"
export * from "./ListaSolicitacoesPlanoSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports